import { createSlice } from '@reduxjs/toolkit';

const resolveCurrency = (enabled, preferredCurrencyCookieValue, currencies) => {
    if (!enabled || !preferredCurrencyCookieValue) {
        return null;
    }
    return (
        currencies.find(
            (currency) => currency.code === preferredCurrencyCookieValue
        ) || null
    );
};

const multiCurrencySlice = createSlice({
    name: 'multiCurrency',
    initialState: {},
    reducers: {
        initialize: (_state, { payload }) => {
            const { currencies = [], enabled, preferredCurrency } = payload;

            return {
                enabled,
                currencies,
                preferredCurrency: resolveCurrency(
                    enabled,
                    preferredCurrency,
                    currencies
                )
            };
        },
        setPreferredCurrency: (state, { payload }) => {
            const { enabled, currencies } = state;

            return {
                ...state,
                preferredCurrency: resolveCurrency(
                    enabled,
                    payload.currencyCode,
                    currencies
                )
            };
        }
    }
});

export const { initialize, setPreferredCurrency } = multiCurrencySlice.actions;
export default multiCurrencySlice.reducer;
